"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _index=_interopRequireDefault(require("../caption/index.animation"));var _default={"initial.caption.subCaption":_index.default["initial.caption.caption"]};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/charts/src/_internal/components/sub-caption/index.animation.js
// module id = zKvk
// module chunks = 5